import { useState } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { centralApi } from '@marque/api/central'

// AB#1865 — maintain the platform Anthropic API key (central config secret). The backend already
// reads `anthropic.api-key` (tenant seed generator); this surfaces a UI to set/rotate it.
const field = 'w-full rounded-md border border-neutral-300 px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500'

export function AnthropicKeyCard() {
    const qc = useQueryClient()
    const [value, setValue] = useState('')

    const { data: configured, isLoading } = useQuery({
        queryKey: ['anthropic-key-configured'],
        queryFn: centralApi.getAnthropicKeyConfigured,
    })

    const save = useMutation({
        mutationFn: () => centralApi.setAnthropicKey(value),
        onSuccess: () => {
            setValue('')
            void qc.invalidateQueries({ queryKey: ['anthropic-key-configured'] })
        },
    })

    return (
        <div className="bg-white rounded-lg border border-neutral-200 p-6 mt-6">
            <h2 className="text-lg font-semibold text-neutral-900">AI — Anthropic API Key</h2>
            <p className="mt-1 text-sm text-neutral-500">
                Used for AI-generated tenant demo data. Stored as a Key Vault secret — the value is never shown back.
            </p>
            <div className="mt-4">
                <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${configured ? 'bg-emerald-100 text-emerald-800' : 'bg-neutral-100 text-neutral-600'}`}>
                    {isLoading ? 'Checking…' : configured ? 'Configured' : 'Not configured'}
                </span>
            </div>
            <div className="mt-4">
                <label className="block text-sm font-medium text-neutral-700 mb-1">{configured ? 'Replace key' : 'Set key'}</label>
                <input
                    type="password"
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    placeholder="sk-ant-…"
                    autoComplete="off"
                    className={field}
                />
            </div>
            <div className="mt-4 flex items-center gap-3">
                <button
                    type="button"
                    disabled={!value.trim() || save.isPending}
                    onClick={() => save.mutate()}
                    className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 disabled:opacity-50"
                >
                    {save.isPending ? 'Saving…' : 'Save key'}
                </button>
                {save.isSuccess && <span className="text-sm text-emerald-600">Saved.</span>}
                {save.isError && <span className="text-sm text-red-600">Failed to save.</span>}
            </div>
        </div>
    )
}
